import { Component, Vue } from 'vue-property-decorator';

@Component
export default class AdaptiveSizeClient extends Vue {
  scrollY = 0;

  windowHeight = 0;

  windowWidth = 0;

  documentWidth = 0;

  /**
   * min 401
   * @returns {boolean}
   */
  get xxsUp() {
    return this.windowWidth > 400;
  }

  /**
   * min 768
   * @returns {boolean}
   */
  get smUp() {
    return this.windowWidth > 767;
  }

  /**
   * min 1024
   * @returns {boolean}
   */
  get smdUp() {
    return this.windowWidth > 1023;
  }

  /**
   * min 1200
   * @returns {boolean}
   */
  get lgUp() {
    return this.windowWidth > 1199;
  }

  beforeMount() {
    this.$nextTick(function () {
      window.addEventListener('resize', this.getParams);
      window.addEventListener('scroll', this.getScrollY);
      this.getScrollY();
      this.getParams();
    });
    this.getScrollY();
    this.getParams();
  }

  beforeDestroy() {
    window.removeEventListener('scroll', this.getScrollY);
    window.removeEventListener('resize', this.getParams);
  }

  getWindowHeight() {
    this.windowHeight = window.innerHeight;
  }

  getScrollY() {
    this.scrollY = window.pageYOffset;
  }

  getWindowWidth() {
    this.windowWidth = window.innerWidth;
  }

  getDocumentWidth() {
    this.documentWidth = document.documentElement.clientWidth;
  }

  getParams() {
    this.getWindowHeight();
    this.getWindowWidth();
    this.getDocumentWidth();
  }
}
